import { sentinelToEmpty } from '../sentinelValue'

// AI-CONTEXT: See docs/pitfalls.md#database-url-sentinel-string-persisted
// De bouwer en zijn subpagina's dragen het onderzoek-ID als vierde URL-segment.
// Wordt de bouwer vanuit 'Vragenlijsten' geopend, dan is dat ID er niet — en
// `${researchID}` zette dan letterlijk 'undefined' in de adresbalk, dat door
// Location()[4] weer als string terugkwam en in 'Ongestructureerd interview'
// als ResearchID zou worden opgeslagen. Eén helper voor élke link.

/**
 * @param {string} client - CompagnyID (eerste URL-segment)
 * @param {string} page - Routenaam, bv. 'questionairebuilder'
 * @param {string} questionnaireId
 * @param {string | undefined} researchId - Mag leeg, undefined of een sentinel-string zijn
 * @returns {string} Pad zonder loos laatste segment
 */
const questionnaireBuilderPath = (client, page, questionnaireId, researchId) => {
    const research = sentinelToEmpty(researchId)
    return `/${client}/${page}/${questionnaireId}${research ? `/${research}` : ''}`
}

export default questionnaireBuilderPath
